import { cvUploadResponseSchema } from './company-profile';

import type { CvUploadResponse } from './company-profile';
import type { ValidatingHttpFetcherWithBaseUrl } from '../../../shared/source/validating-http-fetcher';
import type Result from 'true-myth/result';

export type UploadCV = (file: FormData) => Promise<Result<CvUploadResponse, unknown>>;

export const createUploadCV = (dependencies: {
    readonly validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl;
}): UploadCV => {
    const { validatingCobrainerApiFetcher } = dependencies;

    return (formData: FormData) => {
        return validatingCobrainerApiFetcher.post(cvUploadResponseSchema, {
            pathname: '/cv-analysis',
            requestOptions: {
                body: formData,
            },
        });
    };
};
